module.exports = __webpack_public_path__ + "static/media/MZORH6b.d7d94890.png";